/*
    事件处置页面对应接口
 * @Author: LiJunLei 2826904107@qq.com
 * @Date: 2022-12-26 15:15:09
 * @LastEditors: LiJunLei 2826904107@qq.com
 * @LastEditTime: 2023-03-17 13:53:01
 * @FilePath: \emergency-h5\src\api\request\eventCenter\eventReported.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import requests from '@/api/request'
import Cookie from "js-cookie";
let BASE_URL = `api`
let api = {
    add: `${BASE_URL}/emergencyevent/process/add`,//事件处置 
    datileList: `${BASE_URL}/emergencyevent/process/list`,//事件记录列表
    updataDeatil: `${BASE_URL}/emergencyevent/process/update`,//修改事件记录列表
    getupdataDeatil: `${BASE_URL}/emergencyevent/process/get`,//详情事件记录列表
    isTisk: `${BASE_URL}/emergencyevent/process/task/add`,//下派任务
    getResoureList: `${BASE_URL}/emergencyevent/resourceevent/pagelist`,//获取资源列表
    addResource: `${BASE_URL}/emergencyevent/resource/add`,//根据事件 分配资源
    GetResourceList: `${BASE_URL}/emergencyevent/resource/list`,//根据事件 分配资源记录
    updataResourceList: `${BASE_URL}/emergencyevent/resource/update`,//根据事件 修改事件处置资源记录
    uploadWord: `${BASE_URL}/word/event/resource`,//根据事件 导出word
    uploadZip: `${BASE_URL}/word/zip/event`,//根据事件 导出Zip
    reviewAdd: `${BASE_URL}/emergencyevent/review/add`,//事件复核
    reviewList: `${BASE_URL}/emergencyevent/review/list`,//事件复核记录
    updataReview: `${BASE_URL}/emergencyevent/review/update`,//事件复核记录
    furtherreport: `${BASE_URL}/emergencyevent/furtherreport`,//事件续报
    levelreport: `${BASE_URL}/emergencyevent/levelreport`,//下级上报
    pagelistAll: `${BASE_URL}/emergencyevent/all/pagelist`,//所有事件
    getAllEventCount:`${BASE_URL}/emergencyevent/getAllEventCount`,//监听事件上报

}
// 查询
export async function emergencyeventProcessAddAPI(data) {
    return requests({
        url: api.add,
        method: 'post',
        data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}
// 处置记录列表
export async function emergencyeventProcessListAPI(data) {
    return requests({
        url: api.datileList,
        method: 'get',
        params: data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}

// 处置记录列表 更改
export async function emergencyeventProcessUpdateAPI(data) {
    return requests({
        url: api.updataDeatil,
        method: 'post',
        data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}
// 处置记录列表 详情
export async function GetemergencyeventProcessUpdateAPI(data) {
    return requests({
        url: api.getupdataDeatil,
        method: 'get',
        params: data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}
// 处置记录列表 下派任务
export async function isTaskAddAPI(data) {
    return requests({
        url: api.isTisk,
        method: 'post',
        data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}

// 处置记录列表 更改
export async function getResoureListAPI(data) {
    return requests({
        url: api.getResoureList,
        method: 'post',
        data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}
//  根据 事件 分配资源列表
export async function addResoureAPI(data) {
    return requests({
        url: api.addResource,
        method: 'post',
        data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}

//  根据 事件 分配资源 记录列表
export async function GetResourceListAPI(data) {
    return requests({
        url: api.GetResourceList,
        method: 'get',
        params: data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}
//  根据 修改事件处置资源记录
export async function updataResourceListAPI(data) {
    return requests({
        url: api.updataResourceList,
        method: 'post',
        data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}

//  根据 修改事件导出word
export async function uploadWordAPI(data) {
    return requests({
        url: api.uploadWord,
        method: 'get',
        params: data,
        responseType: 'blob',
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}
//  根据 修改事件导出ZIP
export async function uploadZipAPI(data) {
    return requests({
        url: api.uploadZip,
        method: 'get',
        params: data,
        responseType: 'blob',
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}
//  事件复核   
export async function reviewAddAPI(data) {
    return requests({
        url: api.reviewAdd,
        method: 'post',
        data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}
//  事件复核   
export async function reviewListAPI(data) {
    return requests({
        url: api.reviewList,
        method: 'get',
        params: data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}
//  修改事件复核记录  
export async function updataReviewListAPI(data) {
    return requests({
        url: api.updataReview,
        method: 'post',
        data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}
//  事件续报 （应急事件）
export async function furtherreportAPI(data) {
    return requests({
        url: api.furtherreport,
        method: 'post',
        data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}
//  下级事件接报 （待办事件） 
export async function levelreportAPI(data) {
    return requests({
        url: api.levelreport,
        method: 'post',
        data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}

//  下级事件接报 （待办事件） 
export async function pagelistAllAPI(data) {
    return requests({
        url: api.pagelistAll,
        method: 'post',
        data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}

//  下级事件接报 （待办事件） 
export async function getAllEventCountAPI(data) {
    return requests({
        url: api.getAllEventCount,
        method: 'get',
        params: data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}
